import React from 'react';
import {
    Link,
  } from "react-router-dom";
  
class SideNav extends React.Component {
    constructor(){
        super();

        this.state = {
            getYear:  this.getYear()
        };
        this.getYear = this.getYear.bind(this)
    }
    getYear(){
        return new Date().getFullYear()
    }
    render() {
       return (
            <div className="custom_bodycontainer__navbar">
                    <Link to="/home" className="custom_bodycontainer__navbar--link custom_bodycontainer__navbar--link---1"><span className="custom_bodycontainer__navbar--text">home</span></Link>
                    <Link to="/national-news" className="custom_bodycontainer__navbar--link custom_bodycontainer__navbar--link---2 pointernone"><span className="custom_bodycontainer__navbar--text">National news</span></Link>
                    <a href="/" className="custom_bodycontainer__navbar--link custom_bodycontainer__navbar--link---3"><span className="custom_bodycontainer__navbar--text">World news</span></a>
                    <a href="/" className="custom_bodycontainer__navbar--link custom_bodycontainer__navbar--link---4"><span className="custom_bodycontainer__navbar--text">business</span></a>
                    <a href="/" className="custom_bodycontainer__navbar--link custom_bodycontainer__navbar--link---5"><span className="custom_bodycontainer__navbar--text">Infotech</span></a>
                    <a href="/" className="custom_bodycontainer__navbar--link custom_bodycontainer__navbar--link---6"><span className="custom_bodycontainer__navbar--text">sport</span></a>
                    <a href="/" className="custom_bodycontainer__navbar--link custom_bodycontainer__navbar--link---7"><span className="custom_bodycontainer__navbar--text">Weather</span></a>
                    <a href="/" className="custom_bodycontainer__navbar--link custom_bodycontainer__navbar--link---8"><span className="custom_bodycontainer__navbar--text">photo gallery</span></a>
                    <a href="/" className="custom_bodycontainer__navbar--link custom_bodycontainer__navbar--link---9"><span className="custom_bodycontainer__navbar--text">Cartoon gallery</span></a>
                    <span className="custom_bodycontainer__navbar--copytitle">Credits</span>
                    <span className="custom_bodycontainer__navbar--copytext">
                      This replica of the original Stuff website was created by Sungmi Kim, Patrick Crewdson, Janine Fenwick, Emma Chamberlain and John Hartevelt.
                    </span>
                </div>
       );
    }
}

export default SideNav ;